module.exports = __webpack_public_path__ + "img/solution1-banner.83e59d81.jpg";